import { Divider, Grid, ListItemIcon, Typography } from '@mui/material'
import React from 'react'
import AddIcon from '@mui/icons-material/Add';
import styles from "../../../assets/styles/componentStyles/autocomplete/renderCustomOption.module.scss";
import globalStyles from '../../../assets/styles/global.module.scss';
import IconsColor from '../../utility/iconsColor';
import EditIcon from '@mui/icons-material/Edit';
import { greyColor } from '../../../utils/colors';

interface renderCustomOptions {
    autocompleteRenderOptionProps: React.HTMLAttributes<HTMLLIElement>,
    option: any,
    customOptionName: string,
    optionName: string,
    optionLabelKey: string,
    onClickOfCustomOption: () => void,
    flagShowEditOptionIcon?: boolean,
    flagShowDeleteOptionIcon?: boolean,
    onClickOfEditOption?: (event:  React.MouseEvent<HTMLDivElement, MouseEvent>, option: any) => void,
    onClickOfDeleteOption?: (event:  React.MouseEvent<HTMLDivElement, MouseEvent>, option: any) => void,
    flagRenderCustomOption?: boolean,
    renderCustomOption?: (option: any) => JSX.Element
}
function RenderCustomOption(props: renderCustomOptions) {
    const { autocompleteRenderOptionProps, option, customOptionName, optionName, optionLabelKey, onClickOfCustomOption, flagShowEditOptionIcon, flagShowDeleteOptionIcon, onClickOfEditOption, onClickOfDeleteOption, flagRenderCustomOption, renderCustomOption } = props

    const onClickOfActionOptionIcon = (event: React.MouseEvent<HTMLDivElement, MouseEvent>, option: any, onClickOfIcon?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>, option: any) => void) => {
        if(onClickOfIcon){
            onClickOfIcon(event, option);
        }
    }
    
    return (
        <>
            {String(option[optionLabelKey]) === "-1" ?
                <>
                    <ul className={styles.newTagNameUlElement}>
                        <Divider />
                        <li
                            {...autocompleteRenderOptionProps}
                            className={`${autocompleteRenderOptionProps.className} ${styles.addTagListItem}`}
                            onClick={onClickOfCustomOption}
                        >
                            <AddIcon />
                            <Typography className={`${globalStyles.primaryFontSize} ${globalStyles.secondaryFontWeight}`}>{customOptionName}</Typography>
                        </li>
                    </ul>
                </>
                :
                <>
                    <li {...autocompleteRenderOptionProps} key={option[optionLabelKey]}>
                        <Grid container>
                            {flagRenderCustomOption && renderCustomOption ? 
                                renderCustomOption(option)
                                :
                                optionName
                            }
                        </Grid>
                        {(flagShowEditOptionIcon || flagShowDeleteOptionIcon) && 
                            <Grid container justifyContent={"end"} className={styles.updateOptionGrid}>
                                {flagShowEditOptionIcon &&
                                    <Grid item onClick={(e) => e.stopPropagation()}>
                                        <ListItemIcon onClick={(event) => onClickOfActionOptionIcon(event, option, onClickOfEditOption)} className={styles.listItemIcon}>
                                            <EditIcon className={styles.editOptionIcon} />
                                        </ListItemIcon>
                                    </Grid>
                                }
                                {flagShowDeleteOptionIcon &&
                                    <Grid item onClick={(e) => e.stopPropagation()}>
                                        <ListItemIcon onClick={(event) => onClickOfActionOptionIcon(event, option, onClickOfDeleteOption)} className={styles.listItemIcon}>
                                            <IconsColor height="14" width="14" iconName="DeleteIcon" fillColor={greyColor} />
                                        </ListItemIcon>
                                    </Grid>
                                }
                            </Grid>
                        }
                    </li>
                </>

            }
        </>
    )
}

export default RenderCustomOption